// extracted by mini-css-extract-plugin
module.exports = {"lifepal__lead--form":"LeadForm_lifepal__lead--form__3TgaF","light":"LeadForm_light__3MrZL","dark":"LeadForm_dark__1HxHz"};